// Copyright ©️ 2026 eVolve MEP, LLC

import { Alert, Collapse } from '@mantine/core';

import { EvolveIcon } from 'assets/icons/EvolveIcon';
import { useLocalStorage } from 'hooks/useLocalStorage';

export const PendingStatusRetirementBanner = () => {
  const [hidden, setHidden] = useLocalStorage('PENDING_STATUS_RETIREMENT_BANNER_HIDDEN', false);

  return (
    <Collapse expanded={!hidden}>
      <Alert
        title="We're simplifying work order statuses"
        icon={<EvolveIcon icon="Info" color="primary.7" />}
        withCloseButton
        onClose={() => setHidden(true)}
        mb="md"
      >
        Today, opening a <i>Submitted</i> work order moves it to <i>Pending</i>. In a few weeks, the <i>Pending</i>{' '}
        status is going away. <b>Opening a work order won&apos;t change its status.</b> It will stay <i>Submitted</i>{' '}
        until it is approved. Existing <i>Pending</i> work orders will automatically change to <i>Submitted</i> when the
        update takes effect.
      </Alert>
    </Collapse>
  );
};
